import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import storage from '../../utils/persistentStorage';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Phase 18: Public Onboarding - Account Creation
 * Step 2: Register owner/admin account
 */
function PublicOnboardingAccount() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if household_id exists
    const householdId = sessionStorage.getItem('onboarding_household_id');
    if (!householdId) {
      navigate('/family/onboarding/household');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const householdId = sessionStorage.getItem('onboarding_household_id');
      
      const response = await axios.post(`${API}/api/onboarding/account`, {
        household_id: householdId,
        name: name,
        email: email,
        password: password
      });

      // Store auth token for auto-login
      await storage.setItem('family_token', response.data.token);
      await storage.setItem('family_user_id', response.data.user_id);
      
      // Store for next steps
      sessionStorage.setItem('onboarding_user_id', response.data.user_id);
      
      navigate('/family/onboarding/device');
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Erstellen des Accounts');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050816] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Progress */}
        <div className="mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full bg-[#22C55E] text-white flex items-center justify-center font-bold">✓</div>
            <div className="w-16 h-1 bg-[#22C55E]"></div>
            <div className="w-8 h-8 rounded-full bg-[#6DCEE8] text-[#050816] flex items-center justify-center font-bold">2</div>
            <div className="w-16 h-1 bg-neutral-700"></div>
            <div className="w-8 h-8 rounded-full bg-neutral-700 text-neutral-500 flex items-center justify-center font-bold">3</div>
          </div>
          <p className="text-center text-sm text-neutral-400">Schritt 2 von 5</p>
        </div>

        {/* Card */}
        <div className="bg-neutral-900/80 backdrop-blur-xl rounded-2xl p-8 shadow-2xl border border-neutral-600/40">
          <h2 className="text-3xl font-bold text-[#F9FAFB] mb-2">Ihr Account</h2>
          <p className="text-[#CBD5F5] mb-6">Sie werden als Administrator registriert</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ihr vollständiger Name"
                required
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] placeholder-neutral-500 rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">E-Mail</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ihre@email.de"
                required
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] placeholder-neutral-500 rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mindestens 6 Zeichen"
                required
                minLength={6}
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] placeholder-neutral-500 rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="bg-[#EF4444]/10 border border-[#EF4444]/40 text-[#EF4444] px-4 py-3 rounded-xl">
                <span className="font-semibold">⚠️ {error}</span>
              </div>
            )}

            <button
              type="submit"
              className="w-full py-4 bg-gradient-to-r from-[#5B4B8A] to-[#4a3d72] text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Wird erstellt...' : 'Weiter →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PublicOnboardingAccount;
